/*************************************************/
/* SEARCH                                        */
/*************************************************/

export function search() {
    const suggestionsSelector = '.search-suggestions';
    const searchFormSelector = '#searchForm';
    var typeTimer;

    const getAndDisplaySearchResults = query => {
        const endpointUrl = document.querySelector(searchFormSelector).getAttribute('action');
        fetch(`${endpointUrl}?altTemplate=searchSuggestions&q=${query}`)
            .then(response => {
                return response.text();
            }).then(data => {
                document.querySelector.insertAdjacentHTML('beforeend', data);
                document.querySelector.style.display = 'block';
            }).catch(err => {
                console.log('Something went wrong in search fetch');
                console.error(err);
            });
    };

    const init = () => {
        const searchFormInput = document.querySelector(`${searchFormSelector} input`);
        if(searchFormInput) {
            searchFormInput.addEventListener('keyup', () => {
                const searchForm = document.querySelector(searchFormSelector);
                if (searchForm.dataset.showSuggestions === 'False') return;
                searchForm.remove();
                const query = searchFormInput.value;
                clearTimeout(typeTimer);
                typeTimer = setTimeout(() => { 
                    getAndDisplaySearchResults(query);
                }, 500);
            });
        }

        document.addEventListener('click', e => {
            const clickTarget = e.target;
            let searchResultBox = document.querySelector(suggestionsSelector);
            if (searchResultBox && clickTarget !== searchResultBox && !clickTarget.closest(suggestionsSelector)) {
                searchResultBox.remove();
            }
        });
    };

    init();
}
